import React from 'react'
import * as styles from './Title.module.scss'
import cn from 'classnames'

const Title = ({ text, variant, as, className }) => {
  const Component = as || 'h2'

  const classNames = Array.isArray(variant)
    ? variant.map(v => styles[v])
    : [styles[variant]]
  return (
    <Component className={cn(styles.title, ...classNames, className)}>
      {text}
    </Component>
  )
}
export default Title
